module.exports = __webpack_public_path__ + "static/media/ganesha-ji.ab4a9303.png";